<template>
  <div :class="classModifier">
    <slot></slot>
  </div>
</template>
<script>
import route from "vue-router";

export default {
  props: ["qsKey"],
  computed: {
    classModifier: function() {
      return this.$route.query[this.$props.qsKey];
    }
  }
};
</script>
